<div [formGroup]="formGroup">
  <tui-input
    [formControlName]="formControlName"
    [nativeId]="id"
    [pseudoFocus]="focus ?? null"
    [pseudoInvalid]="invalid === undefined ? null : invalid"
    [readOnly]="properties?.readOnly ?? false"
    [tuiHintContent]="hintContent"
    [tuiTextfieldCleaner]="true"
    [tuiTextfieldIconLeft]="icon"
    [tuiTextfieldPostfix]="postfix"
    [tuiTextfieldPrefix]="prefix"
    [tuiTextfieldSize]="size"
    (focusedChange)="handleFocusedChange($event)"
  >
    {{ label }}
    <span
      class="tui-required"
      *ngIf="validators.required"
    ></span>
    <input
      tuiTextfield
      [attr.type]="type"
      [attr.placeholder]="placeholder ?? ''"
      [attr.required]="validators.required"
    />
  </tui-input>
</div>
